import { createFileRoute, Outlet, redirect, useLocation } from '@tanstack/react-router'
import { useSFContext } from '@web/src/contexts/sf-context'
import { authQueryKeys } from '@web/src/hooks/use-auth'
import {
  isLegalPolicyGateAllowlistedPath,
  redirectIfLegalPoliciesNeedAcceptance,
} from '@web/src/lib/legal/redirect-if-legal-policies-need-acceptance'
import { BetterAuthSessionData, SessionSession, SessionUser } from '@web/src/lib/yoga/yoga-auth-context'
import { useEffect } from 'react'

export const Route = createFileRoute('/(auth)')({
  component: Layout,
  beforeLoad: ({ context, location }) => {
    const session: BetterAuthSessionData = context.queryClient.getQueryData(authQueryKeys.session)
    const currentUser = session?.user as SessionUser
    const currentSession = session?.session as SessionSession

    if (!currentSession) {
      throw redirect({ to: '/auth/signup' })
    }

    redirectIfLegalPoliciesNeedAcceptance(currentUser, location.pathname)

    // Send people to the welcome page if they haven't completed the sign up process
    if (
      currentUser &&
      !currentUser?.profile?.signUpCompleted &&
      location.pathname !== '/auth/welcome' &&
      !isLegalPolicyGateAllowlistedPath(location.pathname)
    ) {
      throw redirect({ to: '/auth/welcome' })
    }
  },
})

function Layout() {
  const { setDisplayBackButton } = useSFContext()
  const location = useLocation()

  const showBackButton = location.pathname !== '/' && location.pathname !== '/feed'

  useEffect(() => {
    setDisplayBackButton(showBackButton)
  }, [setDisplayBackButton, showBackButton])

  return <Outlet />
}
